import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
	sports: [],
	sport: {},

	creating: false,
	deleting: false,
	updating: false,
	gettingList: false,
	gettingItem: false,
	importing: false,

	isError: false,
	errorCode: 0,
	errorMessage: null,
};

export const SportSlice = createSlice({
	name: 'sport',
	initialState,
	reducers: {

		clearSportList: (state, action) => {
			return { ...state, sports: [] };
		},

		clearSportItem: (state, action) => {
			return { ...state, sport: {} };
		},

		onLoadCreate: (state, action ) => {
			return {...state, creating: true};
		},

		onLoadDelete: (state, action ) => {
			return {...state, deleting: true};
		},

		onLoadUpdate: (state, action ) => {
			return {...state, updating: true};
		},

		onLoadList: (state, action ) => {
			return {...state, gettingList: true};
		},

		onLoadItem: (state, action ) => {
			return {...state, gettingItem: true};
		},

		onLoadImport: (state, action ) => {
			return {...state, importing: true};
		},

		// Success
		onSuccessCreate: (state, action) => {
			return {...state, creating: false};
		},

		onSuccessDelete: (state, action) => {
			return {...state, deleting: false};
		},

		onSuccessUpdate: (state, action) => {
			return {...state, updating: false};
		},

		onSuccessList: (state, action) => {
			return {...state, sports: action.payload.data, gettingList: false};
		},

		onSuccessItem: (state, action) => {
			return {...state, sport: action.payload.data, gettingItem: false};
		},

		onSuccessImport: (state, action) => {
			return {...state, importing: false};
		},

		// Errors
		onFailCreate: (state, action) => {
			return {...state, creating: false };
		},
		onFailDelete: (state, action) => {
			return {...state, deleting: false };
		},
		onFailUpdate: (state, action) => {
			return {...state, updating: false };
		},
		onFailList: (state, action) => {
			return {...state, sports: [] };
		},
		onFailItem: (state, action) => {
			return {...state, sport: {} };
		},
		onFailImport: (state, action) => {
			return {...state, importing: false };
		},
	},
});

export const {
	clearSportList,
	clearSportItem,
	clearSportSearchResult
} = SportSlice.actions;
